import { Injectable, inject } from '@angular/core'
import { AppDownloadService } from '@ftr/api-core'
import { isInDesktopApp } from '@ftr/foundation'
import { StaticMenuItem } from '@ftr/menus'
import { AppPaths } from '@ftr/routing-paths'

/**
 * Contains navigation items that are used by all users.
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalNavItems {
  private readonly appDownloadService = inject(AppDownloadService)

  myOrders(): StaticMenuItem {
    return {
      title: 'My Orders',
      path: [`/${AppPaths.Orders}`],
    }
  }

  selectCourtSystem(): StaticMenuItem {
    return {
      title: 'Select a Court System',
      path: [`/${AppPaths.CourtSystem}`],
    }
  }

  accountSettings(): StaticMenuItem {
    return {
      title: 'Account Settings',
      path: [`/${AppPaths.Account}`],
    }
  }

  getDesktopApp(): StaticMenuItem {
    if (isInDesktopApp()) {
      return { title: '' }
    }

    return {
      title: 'Get Desktop App',
      onSelect: () => {
        window.open(this.appDownloadService.getStandaloneAppLink(), '_blank')
      },
    }
  }

  logout(): StaticMenuItem {
    return {
      title: 'Log out',
      path: [`/${AppPaths.Logout}`],
    }
  }

  sharedRecordings(): StaticMenuItem {
    return {
      title: 'Shared Recordings',
      path: [`/${AppPaths.SharedRecordings}`],
    }
  }

  myAuditLog(): StaticMenuItem {
    return {
      title: 'My Audit Log',
      path: [`/${AppPaths.AuditLog}`],
    }
  }
}
